<template>
    <button class="btn btn-default btn-with-label" type="button" data-bs-toggle="modal" data-bs-target="#adddeviceModal">
        <span class="btn-label"><i class="fas fa-mobile"></i></span>{{lang('set_mfa_device')}}
    </button>
    <form class="formValidation" id="deviceAddForm" autocomplete="off">
        <div id="adddeviceModal" class="modal fade" role="dialog">
            <div class="modal-dialog">
                <!-- Modal content-->
                <div class="modal-content marginTop50 text-center">
                    <div>
                        <div class="row">
                            <div class="col-md-12">
                                <h2 class="modaltitleHeader">{{ lang('set_a_device_name') }}</h2>
                            </div>
                        </div>
                        <span id="modal_error"></span>
                    </div>
                    <div class="modal-body marginTop20 marginBottom20">
                        <div class="row">
                            <div class="col-12 col-md-12">
                                <!-- the empty div is needed to show the required ui line np-input -->
                            </div>
                            <div class="col-10 col-md-8 offset-2">
                                <div class="form-group">
                                    <input 
                                    id="device_name" 
                                    class="form-control" 
                                    name="device_name" 
                                    required 
                                    :placeholder="cleanAttribute(lang('device_name'))">
                                </div>
                              <p class="text-center fs-sm mt-3 mb-0">{{ lang('login_use_a_device_auth') }}</p>
                            </div>
                            <div class="col-12 col-md-12">
                                <span class="text-danger displayNone" id="add_device_error"></span>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer justify-content-center">
                        <button type="button" class="btn btn-success btn-with-label" id="add_device">
                            <span class="btn-label"><i class="fa fa-check"></i></span>
                            {{lang('act_confirm')}}
                        </button>
                        <button type="button" class="btn btn-danger btn-with-label" data-bs-dismiss="modal">
                            <span class="btn-label"><i class="fa fa-times"></i></span>
                            {{lang('act_cancel')}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <form class="formValidation" id="deviceActivateForm" name="deviceActivateForm" autocomplete="off">
        <div id="activatedeviceotpModal" class="modal fade" role="dialog">
            <div class="modal-dialog">
                <!-- Modal content-->
                <div class="modal-content marginTop50">
                    <div class="text-center">
                        <div class="row">
                            <div class="col-md-12">
                                <h2 class="modaltitleHeader">{{ lang('select_a_device') }}</h2>
                            </div>
                        </div>
                        <span id="modal_error"></span>
                    </div>
                    <div class="modal-body">
                        <div class="row text-center">
                            <div class="col-12 col-md-12">
                                <div class="row">
                                    <div class="col-12 col-md-12">
                                        <span>
                                            {{ lang('scan_qr_with_app') }}
                                        </span>
                                    </div>
                                    <div class="col-12 col-md-12">
                                        <img class="qr-code img-fluid"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row text-center">
                            <div class="col-12 col-md-12">
                                <span class="fw-bold">
                                    {{ lang('input_secret_manually') }}
                                </span>
                                <span
                                    data-container="body"
                                    data-bs-toggle="popover"
                                    :title="lang('input_secret_manually')"
                                    :data-popover-content="lang('pairing_key_tooltip')"
                                    class="helpBtn addPopover helpHeader">
                                  <i tabindex="-1" class="fa fa-info-circle"></i>
                                </span>
                                <div><p class="secret d-inline-block qr_pairing_code user-select-all"></p> <span role='button' class="qr_pairing_code_tag position-absolute ps-1" data-bs-toggle="tooltip" data-bs-trigger="click hover focus manual" data-bs-placement="top" title=""><i class="far fa-copy text-black-50" aria-hidden="true"></i></span></div>
                            </div>
                        </div>
                        <div class="row text-center">
                            <div class="col-12 col-md-12">
                                <label class="main_desc" for="one_time_password">
                                    {{ lang('authenticator_code') }}
                                  <span
                                      data-container="body"
                                      data-bs-toggle="popover"
                                      :title="lang('authenticator_code')"
                                      :data-popover-content="lang('authenticator_code_tooltip')"
                                      class="helpBtn addPopover helpHeader">
                                  <i tabindex="-1" class="fa fa-info-circle"></i>
                                  </span>
                                </label>
                            </div>
                            <div class="col-8 col-md-6 offset-md-3 offset-2">
                                <div class="form-group">
                                    <input 
                                    name="one_time_password"
                                    id="one_time_password"
                                    type="password"
                                    required
                                    class="form-control text-center"
                                    :placeholder="cleanAttribute(lang('authenticator_code'))">
                                </div>
                            </div>
                            <div class="col-12 col-md-12">
                                <span class="text-danger displayNone" id="otp_activation_error">
                                    {{ lang('otp_not_activated') }}
                                </span>
                            </div>
                        </div>
                      <div class="row mfa-device-info mb-3">
                        <div class="col-md-12">
                          <div class="accordion" id="mfa-device-accordion">
                            <div class="accordion-item">
                              <h2 class="accordion-header">
                                <button class="mfa-device-info accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-controls="collapseOne">
                                  {{ lang('mfa_device_mobile_title_learn_more') }}
                                </button>
                              </h2>
                              <div id="collapseOne" class="accordion-collapse collapse" data-bs-parent="#mfa-device-accordion">
                                <div class="accordion-body">
                                  <div class="title">{{lang('mfa_device_mobile_title')}}</div>
                                  <ol class="mfa-device-info">
                                    <li>{{lang('mfa_device_mobile_info_1')}}</li>
                                    <li>{{lang('mfa_device_mobile_info_2')}}</li>
                                    <li>{{lang('mfa_device_mobile_info_3')}}</li>
                                    <li>{{lang('mfa_device_mobile_info_4')}}</li>
                                    <li>{{lang('mfa_device_mobile_info_5')}}</li>
                                  </ol>
                                </div>
                              </div>
                            </div>
                            <div class="accordion-item">
                              <h2 class="accordion-header">
                                <button class="mfa-device-info accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-controls="collapseTwo">
                                  {{lang('mfa_device_browser_title_learn_more')}}
                                </button>
                              </h2>
                              <div id="collapseTwo" class="accordion-collapse collapse" data-bs-parent="#mfa-device-accordion">
                                <div class="accordion-body">
                                  <div class="title">{{lang('mfa_device_browser_title')}}</div>
                                  <ol class="mfa-device-info">
                                    <li>{{lang('mfa_device_browser_info_1')}}</li>
                                    <li>{{lang('mfa_device_browser_info_2')}}</li>
                                    <li>{{lang('mfa_device_browser_info_3')}}</li>
                                    <li>{{lang('mfa_device_browser_info_4')}}</li>
                                    <li>{{lang('mfa_device_browser_info_5')}}</li>
                                  </ol>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="modal-footer justify-content-center">
                        <button type="button" class="btn btn-success btn-with-label" id="activate_device_otp">
                            <span class="btn-label"><i class="fa fa-check"></i></span>
                            {{ lang('act_confirm') }}
                        </button>
                        <button type="button" class="btn btn-danger btn-with-label" data-bs-dismiss="modal">
                            <span class="btn-label"><i class="fa fa-times"></i></span>
                            {{ lang('act_cancel') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
    export default {
        data: function () {
            return {
                setting_up_device: false,
            };
        },
        methods: {
        addDevice: function() {
            const vm = this;
            const $showAddDeviceButton = $('button#add_device');
            $showAddDeviceButton.click(function(e){
                e.preventDefault();
                let form_valid = $('#deviceAddForm').valid();
                if (form_valid) {
                    $showAddDeviceButton.addClass('disabled');
                    let ajaxcall = $.ajax({
                        url: '/myaccount/ajaxadddevice',
                        data: {
                            'device_name': $('#device_name').val(),
                        },
                        type: 'POST',
                        dataType: 'JSON',
                        success: function (data) {
                            if (data.hasOwnProperty('result') && data.result.toUpperCase() == 'SUCCESS') {
                                $('#adddeviceModal').modal('hide');
                                $('#activatedeviceotpModal .qr-code').attr("src", data.qr_code);
                                $('#activatedeviceotpModal .secret').text(data.mfauth);
                                $('button#activate_device_otp').data('device-id', data.device_id);
                                $('#activatedeviceotpModal').modal('show');
                                vm.setting_up_device = true;
                            } else {
                                vm.updateCsrfTokenFromSuccessResponse(ajaxcall);
                                $('#add_device_error').text(data.error.explanation);
                                $('#add_device_error').removeClass('displayNone');
                                $('#add_device_error').show();
                            }
                        },
                        complete: function () {
                            vm.updateCsrfTokenFromSuccessResponse(ajaxcall);
                            $showAddDeviceButton.removeClass('disabled');
                        }
                    });
                }
            });

            let $deviceName = $('#device_name');
            $deviceName.on("keydown", function(e){
                // detect ENTER key
                if (e.keyCode == 13) {
                  // stop FORM from submitting via ENTER key press
                  e.preventDefault ? e.preventDefault() : e.returnValue = false;
                }
            });
        },
        activateOtpDevice: function() {
            const vm = this;
            const $showActivateOtpButton = $('button#activate_device_otp');
            $showActivateOtpButton.click(function(e){
                e.preventDefault();
                vm.activatingOtpDevice();
            });

            let $oneTimePassword = $('#one_time_password');
            $oneTimePassword.on("keydown", function(e){
                // detect ENTER key
                if (e.keyCode == 13) {
                    // stop FORM from submitting via ENTER key press
                    e.preventDefault ? e.preventDefault() : e.returnValue = false;
                    vm.activatingOtpDevice();
                }
            });
        },
        hideModal: function() {
            $('#adddeviceModal').on('hidden.bs.modal', function () {
                $('#add_device_error').addClass('displayNone');
                $('#add_device_error').hide();
            });
        },
        copySecretToClipboard() {
            let qr_pairing_code_tag = $('.qr_pairing_code_tag'), qr_pairing_code = $('.qr_pairing_code');
            qr_pairing_code_tag.hide();
            qr_pairing_code_tag.attr("title", LANGUAGE['copy_to_clipboard']);
            if (navigator.clipboard === undefined) {
                console.error('navigator.clipboard undefined')
                return;
            }
            qr_pairing_code.on('mouseover', function () {
                qr_pairing_code_tag.show();
            })
            qr_pairing_code_tag.on('mouseover', function () {
                let tooltip = bootstrap.Tooltip.getOrCreateInstance(document.getElementsByClassName('qr_pairing_code_tag')[0])
                tooltip.show();
            })
            qr_pairing_code_tag.on('click', function () {
                let copyText = qr_pairing_code.html();
                $(this).tooltip('dispose');

                // Copy the text inside the text field
                navigator.clipboard.writeText(copyText).then(() => {
                    let icon = qr_pairing_code_tag.find('i');
                    icon.removeClass('fa-files-o text-black-50').addClass('fa-check-circle text-success');
                    qr_pairing_code_tag.attr("title", LANGUAGE['copied']);

                    let tooltip = bootstrap.Tooltip.getOrCreateInstance(document.getElementsByClassName('qr_pairing_code_tag')[0])
                    tooltip.show();

                    //Reset
                    setTimeout(() => {
                        qr_pairing_code_tag.tooltip('dispose');
                        // tooltip.dispose();
                        qr_pairing_code_tag.hide();
                        qr_pairing_code_tag.attr("title", LANGUAGE['copy_to_clipboard']);
                        icon.removeClass('fa-check-circle text-success').addClass('fa-files-o text-black-50');
                    }, 2000)
                }, () => {
                    console.error('Failed to copy')
                });
            })
        },
        updateCsrfTokenFromSuccessResponse: function(ajaxcall) {
            const vm = this;
            if (!!ajaxcall) {
                let x_csrf_token = ajaxcall.getResponseHeader('x-csrf-token');
                if (!!x_csrf_token) {
                    vm.updateCsrfToken(x_csrf_token);
                }
            }
        },
        updateCsrfToken: function(header_x_csrf_token) {
            const vm = this;
            let token = header_x_csrf_token.split(';');
            if (!!token && token.length >= 2) {
                vm.setNewCSRF(token[0], token[1], token[2]);
            }
        },
        /**
         * Copied from common.js
         */
        setNewCSRF: function (name, hash, time, refreshUpdate) {
            const vm = this;
            let currentExpiry = $body.data('token-expiry');
            let currentName = $body.data('token-name');
            let cookieToken = vm.getCookie('csrf').split('#');
            if (currentExpiry <= time && (name !== currentName || refreshUpdate === true) && (cookieToken.length !== 3 || cookieToken[2] <= time)) {
                let oldName = $body.data('token-name');
                $body.data('token-name', name);
                $body.data('token-hash', hash);
                $body.data('token-expiry', time);
                $('input[name="' + oldName + '"]').each(function(index){
                    $(vm).attr('name', name);
                    $(vm).val(hash);
                });
                let mewHash = name.toString()+"#"+hash.toString()+"#"+time.toString();
                vm.setCookie('csrf', mewHash, 1)
            }
        },
        /**
         * Copied from common.js
         */
        getCookie: function(name) {
            let nameEQ = name + "=";
            let ca = document.cookie.split(';');
            for (let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) == ' ') c = c.substring(1, c.length);
                if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
            }
            return "";
        },
        /**
         * Copied from common.js
         */
        setCookie: function(cname, cvalue, exdays) {
            const d = new Date();
            d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
            let expires = "expires="+d.toUTCString();
            function encodeCookieComponent(value) {
                return encodeURIComponent(value)
                    .replace(/[(|)|'|"|;|=|\s]/g, encodeURIComponent); // Additional encoding for special characters
            }
            const secureFlag = location.protocol === 'https:' ? 'Secure;' : ''; // Use Secure flag if the page loads over HTTPS
            document.cookie = encodeCookieComponent(cname) + "=" + encodeCookieComponent(cvalue) + ";"
                + expires + ";path=/;" + secureFlag;
        },
        cleanAttribute: function (str = '', field_name = '') {
            const vm = this;
            let prepped_fields = {};
            if (Array.isArray(str)) {
                str.forEach(function (val, i) {
                    str[i] = vm.cleanAttribute(val, field_name);
                });
                return str;
            }

            // we've already prepped a field with this name
            // @todo need to figure out a way to namespace this so
            // that we know the *exact* field and not just one with
            // the same name

            if (prepped_fields.hasOwnProperty(field_name)) {
                return str;
            }

            str = this.htmlspecialchars(str);

            // In case htmlspecialchars misses these.
            str = str.replace(new RegExp("'", 'g'), "&#39;");

            if (field_name != '') {
                prepped_fields[field_name] = field_name;
            }

            return str;
        },
        htmlspecialchars: function (text) {
            var map = {
                '&': '&amp;',
                '<': '&lt;',
                '>': '&gt;',
                '"': '&quot;',
                "'": '&#039;'
            };
            return text.replace(/[&<>"']/g, function(m) { return map[m]; });
        },
        activatingOtpDevice: function () {
            const vm = this;
            const $showActivateOtpButton = $('button#activate_device_otp');
            const $oneTimePassword = $('#one_time_password');
            let rate_limit_error_codes = ['12-01-136', '12-01-141'];
            const valid = vm.validate('#deviceActivateForm');
            if (valid) {
                $showActivateOtpButton.addClass('disabled');
                $('#otp_activation_error').addClass('displayNone');
                let ajaxcall = $.ajax({
                    url: '/myaccount/ajaxactivatedeviceotp',
                    data: {
                        'device_external_id': $showActivateOtpButton.data('device-id'),
                        'otp': $oneTimePassword.val(),
                    },
                    type: 'POST',
                    dataType: 'JSON',
                    success: function (data) {
                        if (data.hasOwnProperty('result') && data.result.toUpperCase() === 'SUCCESS') {
                            window.location.reload();
                        }
                        else {
                            $('#otp_activation_error').removeClass('displayNone');
                            $('#otp_activation_error').text(data.error.explanation);
                            // $('#activatedeviceotpModal .error-message').text(data.error.explanation);
                            if (rate_limit_error_codes.includes(data.error.code)) {
                                // disable otp field and pause for 2 minutes
                                $(this).data.rateLimited = true;
                                $oneTimePassword.prop('disabled', true);
                                setTimeout(function() {
                                    $(this).data.rateLimited = false;
                                    $oneTimePassword.prop('disabled', false);
                                    $showActivateOtpButton.removeClass('disabled');
                                    $('#otp_activation_error').addClass('displayNone');
                                }, 120000);
                            }
                            if (data.error.code === '10-01-015' || data.error.code == '10-01-028') {
                                // session management is broken, revert when fixed
                                window.location.href = '/login/logout';
                            }
                        }
                    },
                    complete: function () {
                        $oneTimePassword.val('');
                        vm.updateCsrfTokenFromSuccessResponse(ajaxcall);
                        if (!$(this).data.rateLimited) {
                            $showActivateOtpButton.removeClass('disabled');
                        }
                    }
                });
            }
        }
      },
      mounted: function () {
          this.addDevice();
          this.activateOtpDevice();
          this.copySecretToClipboard();
          $('#mfa-device-accordion').on('click', () => {
              setTimeout(()=>{
                  $(document).find('label, input, select, textarea').tooltip('hide');
              },100)
          })
          setTimeout(function() {
              $('#deviceActivateForm').formValidator({
                  triggerEvent: '', // event - default 'click'
                  defaultConfig: '', // {} - object to set different configuration in validate.js
                  scrollToError: '', // enable auto-scroll to invalid element default true expect boolean
                  additionalCallbackFunction: ''
              });
          }, 1500);
          this.hideModal();
      }
    }
</script>